<div>
  <!-- Overlay -->
  <div
    (click)="handleOverlayClick($event)"
    class="size-full fixed inset-0 z-[998] bg-black opacity-40"
  ></div>

  <!-- Modal -->
  <div class="max-w-7xl w-11/12 sm:w-auto max-h-full overflow-auto fixed z-[999] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
    <div
      class="p-7 rounded-2xl bg-white animate-scale-in"
      [class]="class"
      [ngStyle]="ngStyle"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
